export class store_carousel_grid_controller {
    constructor(){
        "ngInject"
    }
    
}


// WEBPACK FOOTER //
// ./src/components/store-carousel-grid/store-carousel-grid.controller.ts